<template>
    <framework>
        <template #side>
            <side-panel-nav/>
        </template>
        <template #main>
            <main-header :title="sectionMeta.title" :icon="sectionMeta.icon"/>

            <div class="columns mt-6 mb-6">
                <div class="column is-list">
                    <section v-if="section === 'account'">

                        <ui-card class="content">
                            <p><i class="fas fa-fw fa-user mr-3"></i>Personal Information</p>

                            <div class="columns">
                                <div class="column-is-narrow"><i class="far fa-fw"></i></div>
                                <div class="column is-5">
                                    <div class="has-text-weight-bold is-size-7 ml-3">Full Name</div>
                                    <div class="mt-1 ml-3">
                                        {{ user.first_name }} {{ user.last_name }}
                                        <b-tooltip multilined label="For record keeping purposes, please contact us at support@my247ed.com if you need a name change. Please include a photo of your updated identification with your request.">
                                            <i class="far fa-info-circle ml-2"></i>
                                        </b-tooltip>
                                    </div>
                                </div>
                                <div class="column">
                                    <b-field label="Maiden Name" label-position="inside">
                                        <b-input v-model="user.maiden_name"></b-input>
                                    </b-field>
                                </div>
                                <div class="column">
                                    <b-field label-position="inside" label="Date of Birth">
                                        <b-input v-model="user.dob_on" v-mask="'##/##/####'" placeholder="mm/dd/yyyy"></b-input>
                                    </b-field>
                                </div>
                            </div>
                            <div class="columns">
                                <div class="column-is-narrow"><i class="far fa-fw"></i></div>
                                <div class="column is-3">
                                    <b-field label="Title" label-position="inside">
                                        <b-select v-model="user.title" expanded>
                                            <option v-for="option in titleOptions" :value="option">{{ option }}</option>
                                        </b-select>
                                    </b-field>
                                </div>
                                <div class="column">
                                    <gender-field v-model="user.gender"/>
                                </div>
                            </div>
                            <p><i class="fas fa-fw fa-address-card mr-3"></i>Contact Information</p>
                            <div class="columns">
                                <div class="column-is-narrow"><i class="far fa-fw"></i></div>
                                <div class="column is-7">
                                    <b-field label="Address" label-position="inside" message="Number, street, etc.">
                                        <b-input v-model="user.address"></b-input>
                                    </b-field>
                                </div>
                                <div class="column">
                                    <b-field label="Address 2" label-position="inside" message="Appt. Number, Suite, etc.">
                                        <b-input v-model="user.address_2"></b-input>
                                    </b-field>
                                </div>
                            </div>
                            <div class="columns">
                                <div class="column-is-narrow"><i class="far fa-fw"></i></div>
                                <div class="column">
                                    <b-field label="City" label-position="inside">
                                        <b-input v-model="user.city"></b-input>
                                    </b-field>
                                </div>
                                <div class="column">
                                    <b-field label="State" label-position="inside">
                                        <b-select v-model="user.state" expanded>
                                            <option value="AL">Alabama</option>
                                            <option value="AK">Alaska</option>
                                            <option value="AZ">Arizona</option>
                                            <option value="AR">Arkansas</option>
                                            <option value="CA">California</option>
                                            <option value="CO">Colorado</option>
                                            <option value="CT">Connecticut</option>
                                            <option value="DE">Delaware</option>
                                            <option value="DC">District Of Columbia</option>
                                            <option value="FL">Florida</option>
                                            <option value="GA">Georgia</option>
                                            <option value="HI">Hawaii</option>
                                            <option value="ID">Idaho</option>
                                            <option value="IL">Illinois</option>
                                            <option value="IN">Indiana</option>
                                            <option value="IA">Iowa</option>
                                            <option value="KS">Kansas</option>
                                            <option value="KY">Kentucky</option>
                                            <option value="LA">Louisiana</option>
                                            <option value="ME">Maine</option>
                                            <option value="MD">Maryland</option>
                                            <option value="MA">Massachusetts</option>
                                            <option value="MI">Michigan</option>
                                            <option value="MN">Minnesota</option>
                                            <option value="MS">Mississippi</option>
                                            <option value="MO">Missouri</option>
                                            <option value="MT">Montana</option>
                                            <option value="NE">Nebraska</option>
                                            <option value="NV">Nevada</option>
                                            <option value="NH">New Hampshire</option>
                                            <option value="NJ">New Jersey</option>
                                            <option value="NM">New Mexico</option>
                                            <option value="NY">New York</option>
                                            <option value="NC">North Carolina</option>
                                            <option value="ND">North Dakota</option>
                                            <option value="OH">Ohio</option>
                                            <option value="OK">Oklahoma</option>
                                            <option value="OR">Oregon</option>
                                            <option value="PA">Pennsylvania</option>
                                            <option value="RI">Rhode Island</option>
                                            <option value="SC">South Carolina</option>
                                            <option value="SD">South Dakota</option>
                                            <option value="TN">Tennessee</option>
                                            <option value="TX">Texas</option>
                                            <option value="UT">Utah</option>
                                            <option value="VT">Vermont</option>
                                            <option value="VA">Virginia</option>
                                            <option value="WA">Washington</option>
                                            <option value="WV">West Virginia</option>
                                            <option value="WI">Wisconsin</option>
                                            <option value="WY">Wyoming</option>
                                        </b-select>
                                    </b-field>
                                </div>
                                <div class="column">
                                    <b-field label="Zip" label-position="inside">
                                        <b-input v-model="user.zip" v-mask="'#####'"></b-input>
                                    </b-field>
                                </div>
                            </div>
                            <hr/>
                            <div class="columns">
                                <div class="column-is-narrow"><i class="far fa-fw"></i></div>
                                <div class="column">
                                    <b-field label="Home (Cell) Phone" label-position="inside">
                                        <b-input v-model="user.phone" v-mask="'(###) ###-####'"></b-input>
                                    </b-field>
                                </div>
                                <div class="column">
                                    <b-field label="Work Phone" label-position="inside">
                                        <b-input v-model="user.phone_2" v-mask="'(###) ###-####'"></b-input>
                                    </b-field>
                                </div>
                            </div>

                            <template #footer>
                                <div class="has-text-right">
                                    <b-button type="is-primary" size="is-small" @click="updateAccount" :disabled="processing || !user.first_name || !user.last_name || !user.dob_on || !user.address || !user.city || !user.state || !user.zip || !user.phone || !user.email"><i class="fas fa-check mr-2"></i>Save Changes</b-button>
                                </div>
                            </template>
                        </ui-card>
                    </section>

                    <section v-if="section === 'billing'">

                        <!-- Shortcut: receipts live under Certificates & Forms, but this is
                             where people go looking for them -->
                        <h2 class="mb-5"><i class="fad fa-file-invoice fa-fw mr-3"></i>Receipts</h2>

                        <ui-card class="content">
                            <div class="columns is-vcentered">
                                <div class="column">
                                    <p class="mt-3 mb-3">
                                        <i class="far fa-info-circle fa-fw mr-2 ml-4"></i>Receipts for every card payment on your account (courses, conferences, and application fees) are listed under Certificates &amp; Forms.
                                    </p>
                                </div>
                                <div class="column is-narrow">
                                    <b-button tag="router-link" to="/reports/receipts" type="is-primary" size="is-small"><i class="fas fa-file-invoice mr-2"></i>View Receipts</b-button>
                                </div>
                            </div>
                        </ui-card>

                        <h2 class="mb-5 mt-6 pt-5"><i class="fad fa-credit-card fa-fw mr-3"></i>Payment on File</h2>

                        <ui-card class="content">
                            <p class="mt-3 mb-4">
                                <i class="far fa-info-circle fa-fw mr-2 ml-4"></i>Payment information is not required to be on file for your account.
                            </p>
                        </ui-card>

                        <h2 class="mb-5 mt-6 pt-5"><i class="fad fa-money-check-alt fa-fw mr-3"></i>Payment Plans</h2>

                        <ui-card v-if="paymentPlans.length" v-for="plan in paymentPlans">
                            <div class="columns">
                                <div class="column is-narrow">
                                    <i class="fad fa-money-check-alt has-text-primary fa-2x"></i>
                                </div>
                                <div class="column">
                                    <div class="has-text-weight-bold mb-3 is-size-5">
                                        {{plan.nickname}}
                                    </div>

                                    <div>
                                        <strong>{{plan.agreement_total | currency}}</strong> at <strong>{{plan.monthly | currency}}/mo</strong> for <strong>{{plan.term}}</strong> month(s) starting on <strong>{{plan.defer_on | dateOnly}}</strong>.
                                    </div>
                                    <p class="has-text-grey mt-4" v-if="plan.cancelled_at">
                                        <b-tag type="is-dark" class="mr-2">Cancelled</b-tag>This payment plan was cancelled on <strong>{{plan.cancelled_at | dateOnly}}</strong>. No further payments are due. Questions? Contact <a href="mailto:support@my247ed.com">support@my247ed.com</a>.
                                    </p>
                                    <p class="has-text-grey mt-4" v-else-if="!plan.is_tpo">
                                        This is a legacy payment plan. For questions or to make changes to your plan, please contact us at <a href="mailto:support@my247ed.com">support@my247ed.com</a>.
                                    </p>
                                    <div v-else>
                                        <p class="has-text-grey mt-4" >
                                            This payment plan is managed by a private lender, <strong>The Payment Option (TPO)</strong>. Additional information and payment support can be found on their site.  Click 'Manage Payment Plan' to view and access your payment plan.
                                        </p>
                                        <p class="mt-3"><strong>Account: </strong> {{currentUser.email}}</p>
                                    </div>
                                </div>
                            </div>
                            <template #footer>
                                <div class="columns">
                                    <div class="column">

                                    </div>
                                    <div class="column has-text-right" v-if="plan.is_tpo && !plan.cancelled_at">
                                        <b-button tag="a" type="is-primary" href="https://app.thepaymentoption.com" target="_blank" size="is-small"><i class="fas fa-up-right-from-square mr-2"></i>Manage Payment Plan</b-button>
                                    </div>
                                </div>
                            </template>
                        </ui-card>
                        <p class="has-text-white" v-else>
                            <i class="far fa-info-circle fa-fw mr-4 ml-5 pl-3"></i>You do not have any payment plans.
                        </p>


                    </section>

                    <section v-if="section === 'login'">

                        <ui-card class="content">
                            <div class="columns">
                                <div class="column">
                                    <b-field label="Primary E-Mail Address" label-position="inside">
                                        <b-input v-model="user.email"></b-input>
                                    </b-field>
                                </div>
                            </div>
                            <div class="columns">
                                <div class="column">
                                    <b-field label="Secondary E-Mail Address" label-position="inside" message="If you have a second email address enter it as an alternate. It can be used to login and lets us contact you in case your primary e-mail fails.">
                                        <b-input v-model="user.email_alt"></b-input>
                                    </b-field>
                                </div>
                            </div>
                            <div class="columns">
                                <div class="column">
                                    <b-field label="Password" label-position="inside">
                                        <b-input placeholder="Set to change your password..." v-model="user.password"></b-input>
                                    </b-field>
                                </div>
                            </div>

                            <template #footer>
                                <div class="has-text-right">
                                    <b-button type="is-primary" size="is-small" @click="updateAccount" :disabled="processing || !user.first_name || !user.last_name || !user.dob_on || !user.address || !user.city || !user.state || !user.zip || !user.phone || !user.email"><i class="fas fa-check mr-2"></i>Save Changes</b-button>
                                </div>
                            </template>
                        </ui-card>
                    </section>

                    <section v-if="section === 'schedule'">
                        <contracted-schedule-card/>
                    </section>

                    <section v-if="section === 'pd'">
                        <pd-profile-section @go="goSection($event)"/>
                    </section>

                    <section v-if="section === 'certs'">
                        <certifications-section/>
                    </section>

                </div>
            </div>

        </template>
    </framework>
</template>

<script>
    import MainHeader from "../../components/framework/MainHeader";
    import Framework from "../../components/framework/Framework";
    import SidePanelNav from "../../components/framework/SidePanelNav";
    import {mapGetters, mapMutations} from "vuex";
    import UiCard from "../../components/UiCard";
    import ContractedScheduleCard from "../../components/studyActivity/ContractedScheduleCard";
    import GenderField from "../../components/fields/GenderField";
    import PdProfileSection from "../../components/account/PdProfileSection";
    import CertificationsSection from "../../components/account/CertificationsSection";
    import {TITLE_OPTIONS} from "../../constants/profile";
    import {client as http} from "../../http_client";
    import moment from "moment";

    export default {
        components: {UiCard, Framework, SidePanelNav, MainHeader, GenderField, ContractedScheduleCard, PdProfileSection, CertificationsSection},
        props: {
            // Route param (/account/:section); 'account' when absent
            section: {type: String, default: 'account'}
        },
        data: function() {
            return {
                user: {},
                titleOptions: TITLE_OPTIONS,
                processing: false
            };
        },
        computed: {
            // paymentPlans comes from the shared billing store (also feeds
            // the dashboard banners + payment-plan panel)
            ...mapGetters(['currentUser', 'paymentPlans', 'clockHoursOn', 'certificationsLoaded']),
            // The section is the page heading (mirrors the left-panel labels)
            sectionMeta() {
                return {
                    account: {title: 'Account Settings', icon: 'fa-user-gear'},
                    login: {title: 'Login Credentials', icon: 'fa-lock-keyhole'},
                    billing: {title: 'Billing Information', icon: 'fa-credit-card'},
                    schedule: {title: 'Work Schedule', icon: 'fa-briefcase'},
                    pd: {title: 'Professional Development', icon: 'fa-graduation-cap'},
                    certs: {title: 'Certifications & Organizations', icon: 'fa-certificate'},
                }[this.section] || {title: 'Your Account', icon: 'fa-user-circle'};
            }
        },
        methods: {
            // The left-panel submenu drives the section via the route param;
            // in-page jumps (e.g. the PD profile card) go through the router
            // too so the panel highlight and the URL stay in sync.
            goSection: function(key) {
                if (this.section === key) return;
                const to = (key === 'account') ? {path: '/account'} : {name: 'account', params: {section: key}};
                this.$router.push(to).catch(() => {});
            },
            load: function() {
                this.$store.dispatch('getPaymentPlans').catch(err => console.error(err));
            },
            // The Professional Development tab only exists while the WA
            // clock-hours certification is on (Certifications & Organizations
            // is where it gets turned on).
            guardPdSection: function() {
                if (this.section === 'pd' && this.certificationsLoaded && !this.clockHoursOn) this.goSection('certs');
            },
            updateAccount: function() {
                this.processing = true;
                http.put('app/users/', {
                    maiden_name: this.user.maiden_name,
                    title: this.user.title,
                    gender: this.user.gender,
                    password: this.user.password,
                    dob: this.user.dob_on,
                    email: this.user.email,
                    email_2: this.user.email_alt,
                    address: this.user.address,
                    address_2: this.user.address_2,
                    city: this.user.city,
                    state: this.user.state,
                    zip: this.user.zip,
                    phone: this.user.phone,
                    phone_2: this.user.phone_2,
                    district: this.user.district,
                    school: this.user.school,
                    subject_area: this.user.subject_area,
                    grade_level: this.user.grade_level
                }).then(response => {
                    this.user.password = null;
                    this.$notify('success', 'Settings Saved', 'Your changes have been successfully applied.', {duration: 5000, permanent: false});
                    this.processing = false;
                    // TODO doesn't update the user in store?
                }).catch(err => {
                    this.processing = false;
                    const message = (err.response && err.response.data) ? err.response.data : 'Something went wrong saving your changes. Please try again.';
                    this.$notify('error', 'Could Not Save', message, {duration: 8000, permanent: false});
                });
            }
        },
        watch: {
            section: function() {
                this.guardPdSection();
            },
            certificationsLoaded: function() {
                this.guardPdSection();
            }
        },
        mounted: function() {
            this.guardPdSection();
            this.user = {password: null, ...this.currentUser};
            this.user.dob_on = moment(this.user.dob_on).format('MM/DD/YYYY');
            this.load();
        }
    };
</script>

<style lang="scss" scoped>
    h2 {
        font-size: 1.2rem;
        color: white;
        padding-bottom: 0.5rem;
        margin-bottom: 1rem;
        border-bottom: 1px dashed rgba(255, 255, 255, 0.2);

        i {
            color: white;
        }
    }

    h4 {
        font-size: 1.2rem;
        margin-top: 1.5rem;
        margin-bottom: 2rem;
        padding-bottom: 0.8rem;

        i {
            color: #336699;
        }

        border-bottom: 1px dashed #ddd;
    }
</style>
